var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-form',{staticClass:"d-flex align-start",on:{"submit":function($event){$event.preventDefault();}}},[_c('v-text-field',{attrs:{"dense":"","rounded":"","outlined":"","color":"primary","label":"Pesquisar","append-icon":"mdi-search-web"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }